import { Component, Input, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'wms-chips',
  templateUrl: './wms-chips.component.html',
  styleUrls: [],
  imports: [CommonModule, FormsModule],
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
  }]
})
export class WmsChipsComponent {
  @Input() selectedChips: any;
  @Input() name: string;
  inputVal: string;

  removeItem($event: any, index: any) {
    this.selectedChips.splice(index, 1);
  }

  handleEnterKeyPressEvent($event: any) {
    if ($event.key === 'Enter') {
      if (!this.selectedChips.includes(this.inputVal)) {
        this.selectedChips.push(this.inputVal);
      }
      this.inputVal = '';
    }
  }

}
